import React from "react";
// import "./TermsAndConditions.css";

const ShippingPolicy = () => {
    return (
        <div className="tc-container">
            <h1 className="tc-title">Shipping & Delivery Policy</h1>

            <section className="tc-section">
                <h2>1. Shipping Coverage</h2>
                <p>
                    Way4Track provides shipping across India using in-house logistics
                    and trusted delivery partners.
                </p>
                <p>
                    Orders are shipped only to serviceable locations. If a location is
                    not serviceable, the order may be cancelled and refunded as per policy.
                </p>
            </section>

            <section className="tc-section">
                <h2>2. Order Processing & Confirmation</h2>
                <p>Orders are processed only after:</p>
                <ul>
                    <li>Successful payment</li>
                    <li>Internal verification and confirmation</li>
                </ul>
                <p>
                    Processing time depends on verification, availability, and operations.
                </p>
            </section>

            <section className="tc-section">
                <h2>3. Processing Time</h2>
                <p>
                    Orders are generally processed within 1–3 business days after confirmation.
                </p>
                <p>
                    This excludes weekends and public holidays and may vary based on order volume.
                </p>
            </section>

            <section className="tc-section">
                <h2>4. Delivery Timeline</h2>
                <p>
                    Estimated delivery time is 3–10 business days from dispatch.
                </p>
                <ul>
                    <li>Customer location</li>
                    <li>Logistics availability</li>
                    <li>External factors (weather, strikes, etc.)</li>
                </ul>
                <p>Delivery timelines are indicative and not guaranteed.</p>
            </section>

            <section className="tc-section">
                <h2>5. Shipping Charges</h2>
                <p>
                    Shipping charges are applied at the order level.
                </p>
                <ul>
                    <li>Total order value</li>
                    <li>Quantity of items</li>
                </ul>
                <p>
                    Charges are shown clearly at checkout before payment.
                </p>
            </section>

            <section className="tc-section">
                <h2>6. Free Shipping Conditions</h2>
                <p>
                    Free shipping may apply based on order value or quantity.
                </p>
                <p>
                    If order changes before confirmation and eligibility is lost:
                </p>
                <ul>
                    <li>Shipping charges may be recalculated</li>
                    <li>Charges may be deducted</li>
                </ul>
            </section>

            <section className="tc-section">
                <h2>7. Order Tracking</h2>
                <p>
                    Tracking details may be shared via SMS or email after dispatch.
                </p>
                <p>
                    Availability depends on the logistics partner.
                </p>
            </section>

            <section className="tc-section">
                <h2>8. Address Accuracy</h2>
                <p>
                    Customers must provide accurate shipping details.
                </p>
                <ul>
                    <li>Incorrect address</li>
                    <li>Incomplete contact details</li>
                </ul>
                <p>
                    These may result in failed delivery or delays. Re-delivery may incur charges.
                </p>
            </section>

            <section className="tc-section">
                <h2>9. Delivery Attempts</h2>
                <p>
                    Delivery partners may attempt delivery multiple times.
                </p>
                <p>
                    Failed deliveries due to customer issues may result in:
                </p>
                <ul>
                    <li>Return to origin</li>
                    <li>Re-shipping charges</li>
                </ul>
            </section>

            <section className="tc-section">
                <h2>10. Delays & External Factors</h2>
                <p>
                    Delivery may be delayed due to:
                </p>
                <ul>
                    <li>Natural disasters</li>
                    <li>Government restrictions</li>
                    <li>Transport disruptions</li>
                </ul>
                <p>
                    Way4Track is not liable for such delays.
                </p>
            </section>

            <section className="tc-section">
                <h2>11. Damaged or Tampered Packages</h2>
                <p>
                    Customers should inspect packages at delivery.
                </p>
                <ul>
                    <li>Refuse delivery if damaged</li>
                    <li>Record unboxing video</li>
                </ul>
                <p>
                    Claims without proof may not be accepted.
                </p>
            </section>

            <section className="tc-section">
                <h2>12. Lost Shipments</h2>
                <p>
                    If a shipment is lost:
                </p>
                <ul>
                    <li>Investigation will be conducted</li>
                    <li>Resolution provided based on findings</li>
                </ul>
                <p>
                    Refunds are not applicable after confirmation.
                </p>
            </section>

            <section className="tc-section">
                <h2>13. Relation with Replacement Policy</h2>
                <p>
                    Delivery issues are handled along with the Replacement & Service Policy.
                </p>
            </section>

            <section className="tc-section">
                <h2>14. Changes to Policy</h2>
                <p>
                    Way4Track may update shipping terms at any time without prior notice.
                </p>
            </section>

        </div>
    );
};

export default ShippingPolicy;